import httpRequestHandler from './http'

export const createCompany = ({
  legalName: legal_name,
  tradeName: trade_name,
  email,
  cnpj,
  username,
  motherName: mother_name,
  birthDate: birth_date,
  establishmentDate: establishment_date,
  establishmentFormat: establishment_format,
  password,
  phone,
  revenue,
  partnerCpf: partner_document,
  partnerName: legal_representative,
  partnerChanged: partner_changed,
  isPep: is_pep,
  isPepSince: is_pep_since,
  maritalStatus: marital_status,
  gender,
  partnerRevenue: partner_revenue,
  zip,
  street,
  neighborhood,
  city,
  federativeUnit: federative_unit,
  country,
  number,
  complement,
  userAgent: user_agent,
  sponsor,
  partner
}) =>
  httpRequestHandler.post('companies', {
    legal_name,
    trade_name,
    email,
    cnpj,
    username,
    mother_name,
    establishment_date,
    establishment_format,
    revenue,
    password,
    phone,
    legal_representative,
    partner_document,
    partner_revenue,
    partner_changed,
    birth_date,
    is_pep,
    is_pep_since,
    marital_status,
    gender,
    zip,
    street,
    neighborhood,
    city,
    federative_unit,
    country,
    number,
    complement,
    user_agent,
    sponsor,
    partner
  })

export const createUser = ({
  name,
  email,
  cpf,
  username,
  id: id_number,
  idIssuingEntity: dispatcher_identity,
  idIssueDate: id_issue_date,
  motherName: mother_name,
  birthDate: birth_date,
  password,
  phone,
  isPep: is_pep,
  isPepSince: is_pep_since,
  maritalStatus: marital_status,
  gender,
  zip,
  street,
  neighborhood,
  city,
  federativeUnit: federative_unit,
  country,
  number,
  complement,
  userAgent: user_agent,
  sponsor
}) =>
  httpRequestHandler.post('users', {
    name,
    email,
    cpf,
    username,
    id_number,
    dispatcher_identity,
    id_issue_date,
    mother_name,
    birth_date,
    password,
    phone,
    is_pep,
    is_pep_since,
    marital_status,
    gender,
    zip,
    street,
    neighborhood,
    city,
    federative_unit,
    country,
    number,
    complement,
    user_agent,
    sponsor
  })

export const uploadUserPhoto = (cpf, imageType, data) => {
  return httpRequestHandler.post('users/documents', data, {
    params: {image_type: imageType, cpf},
    headers: {'Content-Type': 'multipart/form-data'}
  })
}

export const uploadCompanyDocument = (cnpj, imageType, data, partner = false) => {
  console.log(partner)
  return httpRequestHandler.post('companies/documents', data, {
    params: {image_type: imageType, cnpj, partner},
    headers: {'Content-Type': 'multipart/form-data'}
  })
}

export const createSubAccount = ({
   legalName: legal_name,
   tradeName: trade_name,
   email,
   cnpj,
   username,
   motherName: mother_name,
   birthDate: birth_date,
   establishmentDate: establishment_date,
   establishmentFormat: establishment_format,
   password,
   phone,
   revenue,
   partnerCpf: partner_document,
   partnerName: legal_representative,
   partnerChanged: partner_changed,
   isPep: is_pep,
   isPepSince: is_pep_since,
   maritalStatus: marital_status,
   gender,
   partnerRevenue: partner_revenue,
   zip,
   street,
   neighborhood,
   city,
   federativeUnit: federative_unit,
   country,
   number,
   complement,
   userAgent: user_agent,
   sponsor,
   partner
}) => {
  return httpRequestHandler.post('companies/subaccount', {
    legal_name,
    trade_name,
    email,
    cnpj,
    username,
    mother_name,
    establishment_date,
    establishment_format,
    revenue,
    password,
    phone,
    legal_representative,
    partner_document,
    partner_revenue,
    partner_changed,
    birth_date,
    is_pep,
    is_pep_since,
    marital_status,
    gender,
    zip,
    street,
    neighborhood,
    city,
    federative_unit,
    country,
    number,
    complement,
    user_agent,
    sponsor,
    partner
  })
}

export const createPreUser = ({
    name,
    email,
    phone,
    known
  }) => httpRequestHandler.post('users/pre-register', {
    name,
    email,
    phone,
    known
})
